import React from 'react';
import Button from '@material-ui/core/Button';

function PrimaryDialogButton(props) {
    return (
        <Button variant="contained" color="primary" {...props}>
            {props.children}
        </Button>
    );
}

export default PrimaryDialogButton;